import { type FC, type PropsWithChildren } from 'react'

export const ContactPageLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="w-full bg-light-primary-medium" data-qa-id="contact-page">
      {children}
    </div>
  )
}
